import { useSyncExternalStore } from 'react';

/** Same width as the `lg` breakpoint (side navigation, two-column settings). */
const WIDE = '(min-width: 64rem)';

const subscribe = (onChange: () => void) => {
  const mq = window.matchMedia(WIDE);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
};

/** True on screens wide enough for layouts side by side (desktop, landscape tablet). */
export function useWide(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(WIDE).matches,
    () => false,
  );
}
